<!-- BANNER SECTION START -->
<div class="home-banner-section">
    <div class="home-slider-item">
      <div class="slider-item">
        <div class="container">
          <div class="slider-item-info">
            <div class="slider-item-img-wrap">
              <img src="assets/img/landing-pages/VITG.png" alt="">
            </div>
            <div class="slider-item-details-wrap">
              <h1>RegScale Partners With VITG to Accelerate FedRAMP ATO Process</h1>
              <p> Partner with RegScale to streamline compliance</p>
              <a class="btn-link" href="https://go.regscale.com/RegScale-Create-Account"> Options for getting started →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BANNER SECTION END -->

  <!-- ABOUT SECTION START -->
  <div class="about-section">
    <div class="container">
      <div class="about-section-inner">
        <div class="relationships-left-block about-col6">
          <div class="heading">
            <h2>About The Partner: VITG</h2>
          </div>
          <div class="about-para-box">
               <p>Volpe Information Technology Group (VITG) is an information technology cybersecurity consulting service firm supporting automation and innovation initiatives for the Federal Risk and Authorization Management Program (FedRAMP). VITG is currently leading automation and innovation initiatives as a prime contractor to the GSA FedRAMP PMO where it has developed a threat-based risk profiling methodology and has streamlined the documentation review process.</p>
          </div>
        </div>
        <div class="relationships-right-block about-col6">
          <div class="heading">
            <h2>RegScale, In a Nutshell</h2>
          </div>
          <div class="about-para-box">
                <p>RegScale brings compliance into the modern era through digitization and automation in order to increase scalability while lowering risk, cost, time, and labor. The platform helps organizations move from a manual compliance process to an API-centric, automated approach while keeping compliance documentation continuously up to date. The collaborative capabilities of the platform allow all stakeholders and data owners in the compliance process to work together across platforms to fulfill reporting requirements more quickly and accurately.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ABOUT SECTION END -->

  <!-- ATO PROGRES SECTION START -->
  <div class="ato-progres-section">
    <div class="container">
      <div class="heading">
        <h3>How Will RegScale & VITG Accelerate the FedRAMP ATO Process?</h3>
        <p>The partnership between RegScale and VITG will provide the technology and proven methodology to streamline compliance and audit readiness including the requirements for security assessments, authorizations, and continuous monitoring for cloud products and services.</p>
      </div>
      <div class="ato-progres-wrap">
        <div class="ato-progres-item">
          <div class="ato-progres-info">
            <div class="ato-progres-img-wrap">
                <img src="assets/img/team/karmel.jpg" alt="Anil Karmel" />
            </div>
            <div class="ato-progres-info-wrap">
              <p> <em>“Today’s customers are often faced with two challenges,” said Anil Karmel, co-founder and Chief Executive Officer, RegScale. “First, they must modernize and pivot from static compliance documentation and processes to digital and automated solutions. Second, they need to reliably submit documentation for FedRAMP ATO knowing that they have done everything necessary in advance to accelerate approval. The partnership with VITG makes both possible.”</em></p>
            </div>
          </div>
        </div>
        <div class="ato-progres-item">
          <div class="ato-progres-info">
            <div class="ato-progres-img-wrap">
                <img src="assets/img/team/karmel.jpg" alt="VITG - Volpe Junior" />
            </div>
            <div class="ato-progres-info-wrap">
              <p><em>“Currently, the entire FedRAMP ATO process can take 24 months or more including preparation, third-party assessment (3PAO), and ATO reviews,” said Tom Volpe Jr, Chief Operating Officer, VITG. “This partnership is unique because the two companies bring proven expertise that can help customers avoid costly delays while keeping up with the ongoing compliance and cybersecurity requirements of this detailed process.”</em></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ATO PROGRES SECTION END -->

  <!-- WHERE GO FROM HERE SECTION START -->
  <div class="where-go-section">
    <div class="container">
      <div class="where-go-wrap">
        <div class="heading">
          <h4>Where do we go from here?</h4>
        </div>
        <a href="https://go.regscale.com/RegScale-Create-Account" title="Options for getting started" class="btn-red">Options for getting started →</a>
      </div>
    </div>
  </div>
  <!-- WHERE GO FROM HERE SECTION END -->

    <!-- WORK SECTION START -->
    <div class="work-section mb-5">
        <div class="container">
            <div class="heading">
                <h5>Want to become a partner?</h5>
                <p>
                    Join our ecosystem of partners to make the world a safer place through compliance.
                    No<br>contribution is too small and together, we can all make a difference and reimagine a better<br/>
                    world where compliance is cheaper, easier, and more effective
                </p>
                <a [routerLink]="['/partnership']" title="Options for getting started" class="btn-gray">Options for getting started →</a>

            </div>
        </div>
    </div>
   <!-- WORK SECTION END -->
